export default __webpack_public_path__ + "static/media/four.a93120a1.jpeg";